import React from 'react';
import { motion } from 'framer-motion';
import { RocketIcon, TargetIcon, FastForwardIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-electric-700 text-white px-4 relative overflow-hidden" data-id="element-88">
      {/* Dynamic background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-89"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-91">
          <div className="inline-block bg-brandOrange-500 text-white font-bold px-6 py-2 rounded-full mb-6 text-lg uppercase tracking-wider shadow-lg" data-id="element-92">
            La Solución Definitiva
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-93">
            El Método Anti-Perfección (MAP)
          </h2>
          <p className="text-2xl text-electric-100 max-w-3xl mx-auto font-medium" data-id="element-94">
            Este sistema invierte la lógica tradicional. En lugar de diseñar
            primero, validamos rápido.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-96">
            <TargetIcon className="w-12 h-12 text-brandOrange-400 mb-6" data-id="element-97" />
            <h3 className="text-2xl font-bold mb-4" data-id="element-98">Ruta Crítica de Venta</h3>
            <p className="text-electric-50 text-lg" data-id="element-99">
              Solo configuramos lo que nos permite cobrar dinero. Eliminamos la
              estética innecesaria.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-100">
            <FastForwardIcon className="w-12 h-12 text-brandOrange-400 mb-6" data-id="element-101" />
            <h3 className="text-2xl font-bold mb-4" data-id="element-102">
              Velocidad de Implementación
            </h3>
            <p className="text-electric-50 text-lg" data-id="element-103">
              Priorizamos la rapidez. Si una tarea no ayuda a generar una venta
              en 48 horas, se ignora por completo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-104">
            <RocketIcon className="w-12 h-12 text-brandOrange-400 mb-6" data-id="element-105" />
            <h3 className="text-2xl font-bold mb-4" data-id="element-106">Lanzamiento Real</h3>
            <p className="text-electric-50 text-lg" data-id="element-107">
              Pasas de la teoría a tener un negocio vivo, recibiendo tráfico y
              listo para procesar pagos reales.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}